import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'
import { DealerPriceSaveType } from '@schemas'

/** 납품가 관리 (DISPATCH_PLAN §4). 백오피스 전용 — 스태프 토큰 */
export const getDealerList = async ({ customHeaders = {} } = {}): Promise<
	ResType | undefined
> => {
	try {
		const req = new ApiRequest({
			method: 'get',
			uri: '/dealer-price',
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getDealerPriceSheet = async ({
	params = { customerId: '' },
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'get',
			uri: `/dealer-price/${params.customerId}`,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const saveDealerPrice = async ({
	params = { customerId: '' },
	body = {} as DealerPriceSaveType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'put',
			uri: `/dealer-price/${params.customerId}`,
			body: body,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const dealerPriceApi = {
	getDealerList,
	getDealerPriceSheet,
	saveDealerPrice,
}

export default dealerPriceApi
